var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 34,
    viewBox: "0 0 54 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6992 3.56934H34.3V29.8045H19.6992V3.56934Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6267 16.6867C20.6267 11.3563 23.1296 6.62832 26.9767 3.56901C24.1495 1.34416 20.5805 0 16.6869 0C7.46256 0 0 7.46256 0 16.6867C0 25.9109 7.46256 33.3734 16.6867 33.3734C20.5803 33.3734 24.1493 32.0293 26.9767 29.8042C23.1296 26.7914 20.6267 22.0171 20.6267 16.6867Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9997 16.6867C53.9997 25.9107 46.5371 33.3734 37.313 33.3734C33.4194 33.3734 29.8504 32.0293 27.0229 29.8042C30.9165 26.7451 33.3732 22.0171 33.3732 16.6867C33.3732 11.3563 30.87 6.62832 27.0229 3.56901C29.8502 1.34416 33.4194 0 37.313 0C46.5371 0 53.9997 7.50901 53.9997 16.6867Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardIcon);
export default __webpack_public_path__ + "static/media/masterCard_icon.3fdd5a78d7f50d276f16f3219fcf5998.svg";
export { ForwardRef as ReactComponent };